import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import WhatsAppFloat from '../../components/ui/WhatsAppFloat';
import SEOHead from '../../components/seo/SEOHead';
import StructuredData from '../../components/seo/StructuredData';

const NuestraHistoria = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";


  const valores = [
    {
      titulo: "Integridad",
      descripcion: "Transparencia total en cada proceso y resultado garantizado.",
      icon: "ri-shield-check-line"
    },
    {
      titulo: "Excelencia",
      descripcion: "Estándares superiores en cada servicio que ofrecemos.",
      icon: "ri-star-line"
    },
    {
      titulo: "Compromiso",
      descripcion: "Dedicación completa al éxito financiero de nuestros clientes.",
      icon: "ri-heart-line"
    },
    {
      titulo: "Innovación",
      descripcion: "Estrategias vanguardistas adaptadas al mercado actual.",
      icon: "ri-rocket-line"
    }
  ];

  const logros = [
    {
      numero: "100+",
      descripcion: "Empresarios Transformados",
      icon: "ri-user-star-line"
    },
    {
      numero: "$20M+",
      descripcion: "Capital Facilitado",
      icon: "ri-money-dollar-circle-line"
    },
    {
      numero: "100%",
      descripcion: "Tasa de Éxito",
      icon: "ri-trophy-line"
    },
    {
      numero: "5+",
      descripcion: "Años de Experiencia",
      icon: "ri-time-line"
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      <SEOHead
        title="Nuestra Historia CashFlow VIP | Ariel Ruiz y Fior Marte Fundadores Miami"
        description="Conoce la historia de CashFlow VIP y sus fundadores Ariel Ruiz y Fior Marte. 5+ años transformando la realidad financiera de empresarios hispanos en Miami y Estados Unidos."
        keywords="historia CashFlow VIP, Ariel Ruiz, Fior Marte, fundadores, empresarios hispanos, Miami, transformación financiera"
        canonical={`${siteUrl}/nuestra-historia`}
      />

      <StructuredData
        type="WebPage"
        data={{
          title: "Nuestra Historia",
          description: "La historia de dos visionarios que transformaron la realidad financiera de miles de empresarios hispanos en Estados Unidos",
          path: "/nuestra-historia"
        }}
      />

      <Header />

      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-20 left-10 w-64 h-64 bg-yellow-500 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow-500 rounded-full blur-3xl"></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-16">
              <h1 className="text-5xl md:text-6xl font-black text-white font-montserrat mb-6">
                Nuestra <span className="text-yellow-500">Historia</span>
              </h1>
              <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
                La historia de dos visionarios que transformaron la realidad financiera
                de miles de empresarios hispanos en Estados Unidos.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {logros.map((logro, index) => (
                <div key={index} className="text-center">
                  <div className="flex items-center justify-center w-16 h-16 bg-yellow-500/20 rounded-full mx-auto mb-4">
                    <i className={`${logro.icon} text-2xl text-yellow-500`}></i>
                  </div>
                  <div className="text-3xl md:text-4xl font-bold text-yellow-500 mb-2">
                    {logro.numero}
                  </div>
                  <div className="text-gray-300 text-sm md:text-base">
                    {logro.descripcion}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Historia Real */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl font-bold text-white font-montserrat mb-8">
                Nuestra Historia
              </h2>
              <div className="space-y-6 text-xl text-gray-300 leading-relaxed">
                <p>
                  Nuestra historia también empezó desde abajo: Ariel y yo éramos grandes empresarios, pero cuando nuestro negocio cayó, se dañó nuestro crédito. Al buscar cómo repararlo, descubrimos la falta de educación financiera en nuestra comunidad y empezamos ayudando gratis. Con el tiempo, lo convertimos en un sistema que ahora permite a cientos de hispanos crecer y financiar sus sueños.
                </p>
                <p>
                  Hoy, con Cashflow VIP, nos enfocamos en un solo propósito: dar a los hispanos las claves para acceder al crédito y al financiamiento que necesitan para escalar sus vidas y negocios.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Fundadores */}
        <section className="py-20 bg-gray-900">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white font-montserrat mb-4">
                Los Fundadores
              </h2>
              <p className="text-gray-300 max-w-2xl mx-auto">
                Conoce a los visionarios detrás de CashFlow VIP y su misión de transformar vidas.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
              {/* Imagen Principal de los Fundadores */}
              <div className="lg:col-span-2 mb-12">
                <div className="relative overflow-hidden rounded-2xl max-w-2xl mx-auto">
                  <img
                    src="/images/878e867da1b36d45914141269b250482.webp"
                    alt="Ariel Ruiz y Fior Marte - Fundadores de CashFlow VIP"
                    className="w-full h-auto object-contain"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-8 left-8">
                    <h3 className="text-3xl font-bold text-white mb-2">Ariel Ruiz & Fior Marte</h3>
                    <p className="text-yellow-500 font-semibold text-lg">Fundadores & CEOs de CashFlow VIP</p>
                  </div>
                </div>
              </div>

              {/* Perfil Ariel Ruiz */}
              <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700">
                <div className="text-center mb-6">
                  {/* Espacio reservado para imagen individual de Ariel */}
                  <div className="w-32 h-32 bg-gray-700 rounded-full mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-user-line text-4xl text-gray-400"></i>
                    <span className="sr-only">Foto de Ariel Ruiz próximamente</span>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">Ariel Ruiz</h3>
                  <p className="text-yellow-500 font-semibold">Co-Fundador & CEO</p>
                </div>

                <div className="space-y-4">
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-2">Experiencia</h4>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      5+ años en servicios financieros especializados. Experto en estructuración
                      corporativa y acceso a capital para empresarios hispanos.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-white mb-2">Especialidades</h4>
                    <ul className="space-y-2">
                      {[
                        'Formación de Corporaciones',
                        'Estrategias de Funding',
                        'Optimización Fiscal',
                        'Mentoría Empresarial'
                      ].map((especialidad, index) => (
                        <li key={index} className="flex items-center space-x-2">
                          <i className="ri-check-line text-yellow-500"></i>
                          <span className="text-gray-300 text-sm">{especialidad}</span>
                        </li>
                      ))}
                    </ul>
                  </div>


                </div>
              </div>

              {/* Perfil Fior Marte */}
              <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700">
                <div className="text-center mb-6">
                  {/* Espacio reservado para imagen individual de Fior */}
                  <div className="w-32 h-32 bg-gray-700 rounded-full mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-user-line text-4xl text-gray-400"></i>
                    <span className="sr-only">Foto de Fior Marte próximamente</span>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">Fior Marte</h3>
                  <p className="text-yellow-500 font-semibold">Co-Fundadora & CPA</p>
                </div>

                <div className="space-y-4">
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-2">Experiencia</h4>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      CPA certificada con 5+ años especializándose en reparación de crédito
                      y planificación financiera estratégica.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-white mb-2">Especialidades</h4>
                    <ul className="space-y-2">
                      {[
                        'Reparación de Crédito',
                        'Planificación Financiera',
                        'Análisis Crediticio',
                        'Educación Financiera'
                      ].map((especialidad, index) => (
                        <li key={index} className="flex items-center space-x-2">
                          <i className="ri-check-line text-yellow-500"></i>
                          <span className="text-gray-300 text-sm">{especialidad}</span>
                        </li>
                      ))}
                    </ul>
                  </div>


                </div>
              </div>
            </div>

            {/* Misión Conjunta */}
            <div className="mt-16 max-w-4xl mx-auto">
              <div className="bg-gradient-to-r from-yellow-500/10 to-yellow-600/10 border border-yellow-500/30 rounded-2xl p-8 backdrop-blur-sm">
                <div className="text-center mb-6">
                  <h3 className="text-3xl font-bold text-white mb-4">Nuestra Misión</h3>
                </div>
                <p className="text-gray-300 text-lg leading-relaxed text-center">
                  "Reestructura el perfil crediticio de las personas para lograr financiamiento buscando el 0% de interés."
                </p>
                <div className="flex justify-center mt-6">
                  <div className="flex items-center space-x-4">
                    <div className="text-center">
                      <div className="text-yellow-500 font-bold">Ariel Ruiz</div>
                      <div className="text-gray-400 text-sm">Co-Fundador</div>
                    </div>
                    <div className="text-yellow-500 text-2xl">&</div>
                    <div className="text-center">
                      <div className="text-yellow-500 font-bold">Fior Marte</div>
                      <div className="text-gray-400 text-sm">Co-Fundadora</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Propósito */}
            <div className="mt-8 max-w-4xl mx-auto">
              <div className="bg-gradient-to-r from-gray-800 to-gray-900 border border-gray-700 rounded-2xl p-8 backdrop-blur-sm">
                <div className="text-center mb-6">
                  <h3 className="text-3xl font-bold text-white mb-4">Nuestro Propósito</h3>
                </div>
                <p className="text-gray-300 text-lg leading-relaxed text-center">
                  "Transformar vidas con el crédito y el financiamiento al 0% a nuestra comunidad hispana."
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Valores */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white font-montserrat mb-4">
                Nuestros Valores
              </h2>
              <p className="text-gray-300 max-w-2xl mx-auto">
                Los principios fundamentales que guían cada decisión y acción en CashFlow VIP.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {valores.map((valor, index) => (
                <div key={index} className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 hover:border-yellow-500/50 transition-all duration-300">
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="flex items-center justify-center w-16 h-16 bg-yellow-500 rounded-full">
                      <i className={`${valor.icon} text-2xl text-black`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-white">
                      {valor.titulo}
                    </h3>
                  </div>
                  <p className="text-gray-300 leading-relaxed">
                    {valor.descripcion}
                  </p>
                </div>
              ))}
            </div>

            {/* Compromiso */}
            <div className="mt-16 max-w-4xl mx-auto">
              <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700">
                <div className="text-center">
                  <h3 className="text-3xl font-bold text-white mb-6">Nuestro Compromiso</h3>
                  <p className="text-gray-300 text-lg leading-relaxed mb-8">
                    En CashFlow VIP, no solo ofrecemos servicios financieros. Construimos relaciones duraderas,
                    creamos oportunidades reales y transformamos vidas. Cada cliente es parte de nuestra familia VIP,
                    y su éxito es nuestro éxito.
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {[
                      { icon: "ri-handshake-line", text: "Relaciones Auténticas" },
                      { icon: "ri-target-line", text: "Resultados Medibles" },
                      { icon: "ri-infinity-line", text: "Compromiso de Por Vida" }
                    ].map((item, index) => (
                      <div key={index} className="text-center">
                        <div className="flex items-center justify-center w-12 h-12 bg-yellow-500 rounded-full mx-auto mb-3">
                          <i className={`${item.icon} text-xl text-black`}></i>
                        </div>
                        <div className="text-white font-semibold">{item.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-gray-900 to-black">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl md:text-5xl font-bold text-white font-montserrat mb-6">
                ¿Listo para Escribir tu Historia de Éxito?
              </h2>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Únete a los miles de empresarios que ya han transformado su futuro financiero
                con la guía experta de Ariel y Fior.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                {[
                  {
                    icon: "ri-user-star-line",
                    titulo: "Mentoría Directa",
                    descripcion: "Acceso personal a Ariel y Fior"
                  },
                  {
                    icon: "ri-trophy-line",
                    titulo: "Resultados Probados",
                    descripcion: "100% de tasa de éxito garantizada"
                  },
                  {
                    icon: "ri-team-line",
                    titulo: "Red VIP",
                    descripcion: "Conecta con empresarios exitosos"
                  }
                ].map((beneficio, index) => (
                  <div key={index} className="text-center">
                    <div className="flex items-center justify-center w-16 h-16 bg-yellow-500 rounded-full mx-auto mb-4">
                      <i className={`${beneficio.icon} text-2xl text-black`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{beneficio.titulo}</h3>
                    <p className="text-gray-300">{beneficio.descripcion}</p>
                  </div>
                ))}
              </div>

              <div className="space-y-4">
                <a
                  href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black px-12 py-4 rounded-lg font-bold text-lg transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/25 whitespace-nowrap"
                >
                  Agenda tu Evaluación Gratuita
                </a>
                <p className="text-gray-400">
                  Consulta inicial sin costo - Descubre tu potencial financiero
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default NuestraHistoria;
